import { useCallback, useReducer } from "react";
import { LightBoxApiContext } from "./context";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
type ImageData = {
  src: string;
  alt: string;
};
type AddImageAction = {
  type: "ADD_IMAGE";
  payload: ImageData;
};
type RemoveImageAction = {
  type: "REMOVE_IMAGE";
  payload: {
    src: string;
  };
};
type OpenAction = {
  type: "OPEN_IMAGE";
  payload: {
    src: string;
  };
};
type NextAction = {
  type: "NEXT_IMAGE";
};
type PreviousAction = {
  type: "PREVIOUS_IMAGE";
};
type CloseAction = {
  type: "CLOSE";
};
type State = {
  images: ImageData[];
  index: undefined | number;
};
type Actions = AddImageAction | RemoveImageAction | OpenAction | NextAction | PreviousAction | CloseAction;
const INITIAL_STATE = {
  images: [],
  index: undefined
};

function imagesReducer(state: State = INITIAL_STATE, action: Actions): State {
  switch (action.type) {
    case "ADD_IMAGE":
      {
        const images = [...state.images, action.payload];
        return { ...state,
          images
        };
      }

    case "REMOVE_IMAGE":
      {
        const images = state.images.filter(data => {
          return data.src !== action.payload.src;
        });
        let index = undefined;

        if (state.index !== undefined && state.index > images.length) {
          index = images.length - 1;

          if (index === -1) {
            index = undefined;
          }
        }

        return { ...state,
          images,
          index
        };
      }

    case "OPEN_IMAGE":
      {
        const index = state.images.findIndex(data => {
          return data.src === action.payload.src;
        });
        console.log(state.images, index); // debugger;

        return { ...state,
          index: index !== -1 ? index : undefined
        };
      }

    case "NEXT_IMAGE":
      {
        const {
          images,
          index
        } = state;

        if (index === undefined) {
          return state;
        }

        const newIndex = (index + images.length + 1) % images.length;
        return { ...state,
          index: newIndex
        };
      }

    case "PREVIOUS_IMAGE":
      {
        const {
          images,
          index
        } = state;

        if (index === undefined) {
          return state;
        }

        const newIndex = (index + images.length - 1) % images.length;
        return { ...state,
          index: newIndex
        };
      }

    case "CLOSE":
      {
        return { ...state,
          index: undefined
        };
      }

    default:
      {
        return state;
      }
  }
}

export default function LightBoxProvider(props: {
  children: React.ReactNode;
}): JSX.Element {
  const [state, dispatch] = useReducer(imagesReducer, INITIAL_STATE);
  const addImage = useCallback((src: string, alt: string) => {
    dispatch({
      type: "ADD_IMAGE",
      payload: {
        src,
        alt
      }
    });
  }, [dispatch]);
  const removeImage = useCallback((src: string) => {
    dispatch({
      type: "REMOVE_IMAGE",
      payload: {
        src
      }
    });
  }, [dispatch]);
  const open = useCallback((src: string) => {
    dispatch({
      type: "OPEN_IMAGE",
      payload: {
        src
      }
    });
  }, [dispatch]);
  const {
    images,
    index
  } = state;
  return <LightBoxApiContext.Provider value={{
    open,
    removeImage,
    addImage
  }}>
      {props.children}
      {index !== undefined && <Lightbox mainSrc={images[index].src} nextSrc={images[(index + 1) % images.length].src} prevSrc={images[(index + images.length - 1) % images.length].src} onCloseRequest={() => dispatch({
      type: "CLOSE"
    })} onMovePrevRequest={() => dispatch({
      type: "PREVIOUS_IMAGE"
    })} onMoveNextRequest={() => dispatch({
      type: "NEXT_IMAGE"
    })} />}
    </LightBoxApiContext.Provider>;
}